// **********************************************************
// Collection Product Card Slider
// **********************************************************

const collectionProductSlider = document.querySelectorAll('[data-slider="collection-product-slider"]');

const collectionProductSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  speed: 600,
  watchOverflow: true,
  breakpoints: {
    767: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1023: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1199: {
      slidesPerView: 4,
      slidesPerGroup: 2,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

collectionProductSlider.forEach((el) => {
  const collectionProductSliderParent = el.closest('.collection-banner__product-list');
  const arrowRight = collectionProductSliderParent.querySelector('.arrow-right');
  const arrowLeft = collectionProductSliderParent.querySelector('.arrow-left');

  collectionProductSliderOptions.navigation.nextEl = arrowRight;
  collectionProductSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, collectionProductSliderOptions);
});
